import { createGetTextResources } from "../../shared/utils/text-resources-algemeen";

export const getKapitaalverzekeringTextResources = createGetTextResources({
  ErrorUitsteldatumInDeToekomst: "Vul een uitsteldatum in de toekomst in.",
  ErrorUitsteldatumInvullen: "Vul een uitsteldatum in."
});
